import { Container, Paper, Typography } from "@material-ui/core";
import MuiLink from "@material-ui/core/Link";
import React from "react";
import { Link } from "react-router-dom";
import { DataNotAvailable } from "../../../plchina/DataNotAvailable";

export const ReportsList = () => {
  if (localStorage.getItem("theme") === "2") {
    return <DataNotAvailable />;
  }

  return (
    <>
      <Container>
        <Typography variant="h4">Report Management</Typography>
        <Paper>
          <MuiLink component={Link} to={"/reports/report_team"}>
            <Typography variant="h6">Report Team</Typography>
          </MuiLink>

          <MuiLink component={Link} to={"/reports/report_sequence_definition"}>
            <Typography variant="h6">Report Sequence Definitions</Typography>
          </MuiLink>

          <MuiLink component={Link} to={"/reports/report_writers_agenda"}>
            <Typography variant="h6">Report Writer's Agenda</Typography>
          </MuiLink>
          <MuiLink component={Link} to={"/reports/report_module"}>
            <Typography variant="h6">Report Writer's Agenda New UI</Typography>
          </MuiLink>

          <MuiLink component={Link} to={"/reports/report_approver_agenda"}>
            <Typography variant="h6">Report Approver's Agenda</Typography>
          </MuiLink>
          <MuiLink component={Link} to={"/reports/report_document"}>
            <Typography variant="h6">Report Document Upload</Typography>
          </MuiLink>
           <MuiLink component={Link} to={"reports/checklist_upload/"}>
            <Typography variant="h6">Report Checklist Upload</Typography>
          </MuiLink>
        </Paper>
      </Container>
    </>
  );
};
